// extracted by mini-css-extract-plugin
export default {"grid":"SectionBodyGrid_grid__Mlo45","block":"SectionBodyGrid_block__qDcVP"};